module.exports = __webpack_public_path__ + "static/logo-a5848cac3a1009c71a23ac2fe4047d31.svg";